import React from 'react';
import { useContent } from '../../context/ContentContext';
import { DEFAULT_HOME_VERSES, resolveHomeVerses } from '../../data/homeVerses';

export default function EditorPanelVersesDetail() {
  const { getContent, setContentValue } = useContent();
  const verses = resolveHomeVerses(getContent);

  const saveVerses = (nextVerses) => {
    setContentValue('home.verses.items', nextVerses);
  };

  const updateVerse = (index, patch) => {
    saveVerses(verses.map((verse, idx) => (idx === index ? { ...verse, ...patch } : verse)));
  };

  const removeVerse = (index) => {
    if (verses.length <= 1) {
      window.alert('You need at least one Bible verse.');
      return;
    }
    if (!window.confirm('Remove this verse?')) return;
    saveVerses(verses.filter((_, idx) => idx !== index));
  };

  const addVerse = () => {
    saveVerses([
      ...verses,
      {
        text: DEFAULT_HOME_VERSES[0]?.text || 'Enter verse text',
        reference: DEFAULT_HOME_VERSES[0]?.reference || 'Reference',
      },
    ]);
  };

  return (
    <div className="editor-panel__detail" onClick={(e) => e.stopPropagation()}>
      <p className="editor-panel__detail-lead">Edit verse text and references. Verses rotate on the page automatically.</p>

      <ul className="editor-panel__detail-list">
        {verses.map((verse, index) => (
          <li key={`verse-${index}`} className="editor-panel__detail-card">
            <div className="editor-panel__detail-card-head">
              <span className="editor-panel__detail-card-title">Verse {index + 1}</span>
            </div>

            <label className="editor-panel__detail-label" htmlFor={`verse-${index}-text`}>
              Verse text
            </label>
            <textarea
              id={`verse-${index}-text`}
              className="editor-panel__detail-textarea"
              rows={3}
              value={verse.text}
              onChange={(e) => updateVerse(index, { text: e.target.value })}
            />

            <label className="editor-panel__detail-label" htmlFor={`verse-${index}-reference`}>
              Reference
            </label>
            <input
              id={`verse-${index}-reference`}
              type="text"
              className="editor-panel__detail-input"
              value={verse.reference}
              placeholder="Book chapter:verse"
              onChange={(e) => updateVerse(index, { reference: e.target.value })}
            />

            <div className="editor-panel__detail-btn-row">
              <button
                type="button"
                className="editor-panel__detail-btn editor-panel__detail-btn--danger"
                onClick={() => removeVerse(index)}
              >
                Remove verse
              </button>
            </div>
          </li>
        ))}
      </ul>

      <div className="editor-panel__detail-btn-row editor-panel__detail-btn-row--footer">
        <button type="button" className="editor-panel__detail-btn editor-panel__detail-btn--primary" onClick={addVerse}>
          + Add verse
        </button>
      </div>
    </div>
  );
}
